




















































































































import Vue from 'vue'
import UISidePanel from "../../../components/tailwind/UISidePanel.vue";
import {User} from "../../../../models";
import firebase from "firebase/compat/app";
import LocationServices from "../../../../services/LocationServices";
import to from "await-to-js";
import {UxMessage} from "../../../../util/ux_message";
import CompanyService from '../../../../services/CompanyService';

export default Vue.extend({
  components: {
    UISidePanel
  },
  props:{
    feature: {},
    locationId: {
      type: String,
    },
    companyId: {
      type: String,
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user() {
      const user = this.$store.state.user.user
      return user ? new User(user) : undefined
    },
    userDetails() {
      return `${this.user.firstName} (${this.user.email})`
    }
  },
  created() {
  },
  inject: ['uxmessage'],
  data() {
    return {
      loading: false,
      subject: '',
      description: '',
      attachments: [
      ],
      openSuggestionPanel: true,
    }
  },
  methods: {
    filesChange(files = []){
      const vue = this

      files.forEach(async (file)=>{
        const fileRefName = `/feedbackFiles/${this.locationId}/${file.name}`
        const uploadPath = firebase.storage().ref(fileRefName)

        const snapshot = await uploadPath.put(file, {
            contentDisposition: `inline; filename="${file.name}"`,
          })

        snapshot.ref.getDownloadURL().then(async function (downloadURL) {
          if (downloadURL) {
            vue.attachments.push({
              name: file.name,
              url: downloadURL
            })
          }
        })
      })
    },
    removeFile(fileName){
      this.attachments = this.attachments.filter((file)=>{
       return file.name !== fileName
     })
    },
    resetFields() {
      this.subject= ''
      this.description=''
      this.attachments= []
    },
    async submitFeedback(){
      const result = await this.$validator.validateAll()
      if(result){
        this.loading = true
        const body = {
          featureKey: this.feature.key,
          locationId: this.locationId,
          companyId: this.companyId,
          subject: this.subject,
          description: this.description,
          attachments: this.attachments.map((files)=> files.url)
        }
        let err, response

        if (this.locationId) {
           [err, response] = await to(LocationServices.Lab.addFeedback(this.locationId, body))
        } else {
           [err, response] = await to(CompanyService.Lab.addFeedback(this.companyId, body))
        }

        if(err){
          this.uxmessage(
            UxMessage.errorType('An error has occurred, please try again later', '', undefined),
            true
          )
          this.loading = false
        }else{
          this.uxmessage(
            UxMessage.successType('Your feedback has been submitted', '', undefined),
            true
          )
          this.loading = false
          this.resetFields()
          this.$emit('close')
        }

      }
    },

  },
  watch: {
  }
})
